import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ApplicationConfig, ErrorHandler, importProvidersFrom } from "@angular/core";
import { initializeApp, provideFirebaseApp } from "@angular/fire/app";
import { provideAnimations } from "@angular/platform-browser/animations";
import { environment } from "./environments/environment";
import { connectStorageEmulator, getStorage, provideStorage } from "@angular/fire/storage";
import { StoreModule } from "@ngrx/store";
import { reducers, reportsEffects } from "./app/store";
import { EffectsModule } from "@ngrx/effects";
import { InternalAuthModule } from "core/auth.module";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { provideRouter, withComponentInputBinding, withDebugTracing } from "@angular/router";
import appRoutes from "./app/app.routes";
import { API_AUTH_URL, API_URL_TOKEN, CLIENT_PORTAL_URL, PROD_TOKEN } from "core/tokens/tokens";
import { MatDialogModule } from "@angular/material/dialog";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { ConfigurationService } from "@progress/kendo-angular-charts";
import { GlobalErrorHandler } from "core/error-handle/error-handler";
import { connectFirestoreEmulator, getFirestore, provideFirestore } from "@angular/fire/firestore";
import { connectAuthEmulator, getAuth, provideAuth } from "@angular/fire/auth";


export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      StoreModule.forRoot(reducers, {
        runtimeChecks: {
          strictActionImmutability: false,
          strictActionSerializability: false,
          strictStateImmutability: true,
          strictStateSerializability: true,
        },
      }),
      EffectsModule.forRoot(reportsEffects),
      InternalAuthModule,
      !environment.production ? StoreDevtoolsModule.instrument() : [],
      MatDialogModule,
      MatSnackBarModule
    ),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => {
      const auth = getAuth();
      if (environment.useEmulators) {
        connectAuthEmulator(auth, "http://localhost:9099", {
          disableWarnings: true,
        });
      }
      return auth;
    }),
    provideFirestore(() => {
      const firestore = getFirestore();

      if (environment.useEmulators) {
        connectFirestoreEmulator(firestore, "localhost", 8082);
        // enableIndexedDbPersistence(firestore);
      }
      return firestore;
    }),
    provideStorage(() => {
      const storage = getStorage();
      if (environment.useEmulators)
        connectStorageEmulator(storage, "localhost", 9199);
      return storage;
    }),
    provideRouter(
      appRoutes, withComponentInputBinding(),
      // withDebugTracing()
    ),
    [
      { provide: PROD_TOKEN, useValue: environment.production },
      { provide: API_URL_TOKEN, useValue: environment.apiUrl },
      { provide: API_AUTH_URL, useValue: environment.authURL },
      { provide: ConfigurationService },
    { provide: CLIENT_PORTAL_URL, useValue: environment.clientPortalUrl },
    ],
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler 
    },
  ]
};